import styled from '@emotion/styled';

const PlayWrapper = styled('div')({
  height: '100%',
  position: 'absolute',
  width: '100%',
});

export default PlayWrapper;
